import { Controller } from "@hotwired/stimulus";

// The change page: each plan has its own method cards (their copy names the
// plan's cycle) and each plan × method its own summary, all rendered by the
// server; this shows the ones for the choice and blocks a choice that changes
// nothing.
export default class extends Controller<HTMLElement> {
	static targets = ["methods", "summary", "same", "submit", "card"];
	static values = { currentPlan: String, currentMethod: String, reactivate: Boolean };
	declare readonly methodsTargets: HTMLElement[];
	declare readonly summaryTargets: HTMLElement[];
	declare readonly sameTarget: HTMLElement;
	declare readonly submitTarget: HTMLInputElement;
	declare readonly cardTargets: HTMLElement[];
	declare readonly currentPlanValue: string;
	declare readonly currentMethodValue: string;
	declare readonly reactivateValue: boolean;

	connect() {
		this.update();
	}

	update() {
		const plan = this.#checked("subscription[plan_id]");
		const wanted = this.#checked("subscription[billing_type]");
		for (const group of this.methodsTargets) {
			const shown = group.dataset.plan === plan;
			group.hidden = !shown;
			for (const input of group.querySelectorAll<HTMLInputElement>("input[type=radio]")) {
				input.disabled = !shown;
				input.checked = shown && input.value === wanted;
			}
		}
		const method = this.#checked("subscription[billing_type]");
		const state = switchState(plan, method, this.currentPlanValue, this.currentMethodValue, this.reactivateValue);

		for (const summary of this.summaryTargets) {
			summary.hidden = !state.ready || summary.dataset.plan !== plan || summary.dataset.billingType !== method;
		}
		for (const card of this.cardTargets) card.hidden = method !== "credit_card";
		this.sameTarget.hidden = !state.same;
		this.submitTarget.disabled = !state.ready;
		this.submitTarget.classList.toggle("odo-button__secondary", state.ready);
		this.submitTarget.classList.toggle("odo-button__disabled", !state.ready);
	}

	#checked(name: string): string {
		return this.element.querySelector<HTMLInputElement>(`input[name="${name}"]:checked:not(:disabled)`)?.value ?? "";
	}
}

// The same plan and method is no change, except when turning renewal back on.
export function switchState(plan: string, method: string, currentPlan: string, currentMethod: string, reactivate: boolean) {
	const same = !reactivate && plan === currentPlan && method === currentMethod;
	return { same, ready: method !== "" && !same };
}
